module.exports = __webpack_public_path__ + "img/offers.c041080e.svg";